import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppBaseComponent } from '@kiraah-shared/app-skeleton';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends AppBaseComponent implements OnInit {

  constructor(
  ) {
    super();
  }

  ngOnInit() {
    this.initialize();
  }
}
